import { render, staticRenderFns } from "./SegmentListCreateOrEditContactsMatchCount.vue?vue&type=template&id=83a27bf4&scoped=true&"
import script from "./SegmentListCreateOrEditContactsMatchCount.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditContactsMatchCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a27bf4",
  null
  
)

export default component.exports